function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDonut(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 600 600",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,-1055.51,-91.4227)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.17188,0,0,1.17188,1055.51,91.4227)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C397.385,0 512,114.615 512,256L481.095,256C481.095,114.615 380.316,0 256,0Z",
    style: {
      fill: "rgb(0,172,109)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M481.095,256L512,256C512,397.385 397.385,512 256,512C380.316,512 481.095,397.385 481.095,256Z",
    style: {
      fill: "rgb(31,63,217)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.378,256C388.378,182.889 329.111,123.622 256,123.622L256,0C380.316,0 481.095,114.615 481.095,256L388.378,256Z",
    style: {
      fill: "rgb(2,219,140)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.267,127.982C78.534,51.476 161.253,0 256,0L256,123.622C207.006,123.622 164.231,150.24 141.341,189.802L34.267,127.982Z",
    style: {
      fill: "rgb(243,205,81)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.267,384.018C12.478,346.358 -0,302.637 -0,256C-0,209.363 12.478,165.642 34.267,127.982L141.341,189.802C130.074,209.275 123.622,231.883 123.622,256C123.622,280.117 130.074,302.725 141.341,322.198L34.267,384.018Z",
    style: {
      fill: "rgb(253,156,76)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.982,477.733C89.134,455.256 56.744,422.865 34.267,384.018L141.341,322.198C152.964,342.286 169.714,359.036 189.802,370.659L127.982,477.733Z",
    style: {
      fill: "rgb(240,0,180)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.378,256C388.378,329.111 329.111,388.378 256,388.378C231.883,388.378 209.275,381.926 189.802,370.659L127.982,477.733C165.642,499.522 209.363,512 256,512C380.316,512 481.095,397.385 481.095,256L388.378,256Z",
    style: {
      fill: "rgb(61,87,211)",
      fillRule: "nonzero"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDonut);
export default __webpack_public_path__ + "static/media/donut.430d02b80baf0106594783d2dd9ceacf.svg";
export { ForwardRef as ReactComponent };